export {}; // this will make it module
declare global { // this is important to access it as global type String
  interface String {

    isNullOrWhitespace(): boolean;

    trimWhiteSpaces(): string;

    capitalizeFirstLetter(): string;

    toBold(): string;

    toItalic(): string;

    replaceAll(search: string, replacement: string): string;
  }
}

String.prototype.isNullOrWhitespace = function (): boolean {
  return this === null || this.length === 0 || this.trimWhiteSpaces().length === 0;
};

String.prototype.trimWhiteSpaces = function (): string {
  if (!this) {
    return '';
  }
  return this.replace(/ +/g, '');
};
String.prototype.capitalizeFirstLetter = function (): string {
  if (!this) {
    return '';
  }
  return this.charAt(0).toUpperCase() + this.slice(1);
};
String.prototype.toBold = function (): string {
  if (!this) {
    return '';
  }
  return '<strong>' + this + '</strong>';
};
String.prototype.toItalic = function (): string {
  if (!this) {
    return '';
  }
  return '<em>' + this + '</em>';
};

String.prototype.replaceAll = function (search: string, replacement: string): string {
  if (!this) {
    return '';
  }
  return this.split(search).join(replacement);
};
